import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { ConfirmModal } from "src/components";
import useLoginWithRetrunTo from "src/hooks/useLoginWithRetrunTo";
import { errorModalState } from "src/recoil/errorModal/atom";
import { useErrorModal } from "src/recoil/errorModal/hook";

const HTTP_STATUS_MAP = {
  400: "잘못된 요청입니다",
  401: "인증되지 않았습니다",
  403: "권한이 없습니다",
  404: "존재하지 않는 리소스입니다",
  "4xx": "요청 오류입니다",
  "5xx": "오류가 발생하였습니다",
};

export const getStatusMessage = (errorCode: number) => {
  switch (errorCode) {
    case 400:
      return HTTP_STATUS_MAP[400];
    case 401:
      return HTTP_STATUS_MAP[401];
    case 403:
      return HTTP_STATUS_MAP[403];
    case 404:
      return HTTP_STATUS_MAP[404];
    default:
      if (errorCode >= 400 && errorCode < 500) {
        return HTTP_STATUS_MAP["4xx"];
      }
      if (errorCode >= 500 && errorCode < 600) {
        return HTTP_STATUS_MAP["5xx"];
      }
      return "알 수 없는 에러가 발생했습니다";
  }
};

/**
 * recoil errorModalState 를 사용하는
 * api 에러발생시 띄우는 에러 모달 컴포넌트
 */
const ErrorModal = () => {
  const errorModals = useRecoilValue(errorModalState);
  const { closeAllErrorModal } = useErrorModal();
  const { loginWithRetrunTo } = useLoginWithRetrunTo();
  const navigate = useNavigate();
  const { pathname } = useLocation();

  // 공통 에러모달이 아닌 별도 에러모달 오픈 조건

  const handleConfirm = () => {
    closeAllErrorModal();
  };

  const goToMain = () => {
    // pathname 에 PartnerCode 가 있으면 파트너코드 적용된 main 페이지로 이동
    if (pathname.includes("partner")) {
      const partnerCode = pathname.split("/")[3];
      navigate(`/court/partner/${partnerCode}/main`);
    } else {
      navigate("/court/main");
    }
    closeAllErrorModal();
  };

  if (errorModals.length > 0) {
    // 에러모달은 첫번째 하나만 보이게
    const firstErrorModal = errorModals[0];
    // 내부 이용자 에러면
    if (firstErrorModal.errorCode === "ePR0563") {
      // 무인증 상태 > 내부이용자 전용 상품에 접근시
      if (firstErrorModal.errorData === "PUBLIC") {
        closeAllErrorModal();
        loginWithRetrunTo();
      }
      // 인증 상태 > 내부이용자가 아닌데 내부이용자 전용 상품에 접근시 권한 없음 모달
      else {
        return (
          <ConfirmModal isOpen={firstErrorModal.isOpen} btnRightTitle={"확인"} onClick={goToMain}>
            <div style={{ wordBreak: "break-word" }}>
              <p className="font18 font-weight-600 pre-formatted">상품을 조회할 수 있는 권한이 없습니다.</p>
            </div>
          </ConfirmModal>
        );
      }
    } else {
      // 개별 api 에러 모달
      return (
        <ConfirmModal isOpen={firstErrorModal.isOpen} btnRightTitle={"확인"} onClick={handleConfirm}>
          <div style={{ wordBreak: "break-word" }}>
            {!firstErrorModal.errorCode ||
              (firstErrorModal.errorCode !== "eCT801" && ( //
                <b className="font18 font-weight-600">{getStatusMessage(firstErrorModal.statusCode || 0)}</b>
              ))}

            {/* eCT801 (배치 에러) 일 때는 에러 문구 보여주기  / 아닐때는 문구없이 에러코드만*/}
            {firstErrorModal.errorCode && firstErrorModal.errorCode !== "eCT801" ? (
              <div className="font14 mt20 text-primary3">{firstErrorModal?.errorCode || "에러가 발생했습니다."}</div>
            ) : (
              <div className=" font18 font-weight-600 pre-formatted">{firstErrorModal?.errorMessage || "에러가 발생했습니다."}</div>
            )}
          </div>
        </ConfirmModal>
      );
    }
  }
  return null;
};

export default ErrorModal;
